import { render, staticRenderFns } from "./viafree_bokdari.vue?vue&type=template&id=c824a148&scoped=true&"
import script from "./viafree_bokdari.vue?vue&type=script&lang=js&"
export * from "./viafree_bokdari.vue?vue&type=script&lang=js&"
import style0 from "./viafree_bokdari.vue?vue&type=style&index=0&id=c824a148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/registry.npmjs.org/vue-loader/15.8.3_25647bdc581bdda9c9b762adc3f55a51/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c824a148",
  null
  
)

export default component.exports